export class Slider {
    id = 0;
    title = '';
    alt_image = '';
    url_image = '';
    url_link = '';
    clicks = 0;
    views = 0;
    status = 0;
}
